export default "__VITE_ASSET__BFmAXpLB__"